var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconMp418 = function SvgAIconMp418(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.866 9V6.24137C14.8658 5.95858 14.7533 5.68746 14.5532 5.48762L10.3784 1.31216C10.1783 1.11216 9.9069 0.999872 9.62397 1H2.06662C1.47754 1 1 1.47754 1 2.06662V15.9327C1 16.5217 1.47754 16.9993 2.06662 16.9993H3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8663 6.3331H10.5998C10.0107 6.3331 9.5332 5.85555 9.5332 5.26648V1",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34503 17V11.6L6.92252 14.3L5.5 11.6V17",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2412 17V11.6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2412 11.6H10.7154C11.501 11.6 12.1379 12.3253 12.1379 13.22C12.1379 14.1147 11.501 14.84 10.7154 14.84H10.2412",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3682 17V15.92",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3682 15.9205V11.6113C14.8744 12.4509 13.8219 14.0517 13.5352 15.9205H16.3682",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconMp418 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xNC44NjYgOVY2LjI0MTM3QzE0Ljg2NTggNS45NTg1OCAxNC43NTMzIDUuNjg3NDYgMTQuNTUzMiA1LjQ4NzYyTDEwLjM3ODQgMS4zMTIxNkMxMC4xNzgzIDEuMTEyMTYgOS45MDY5IDAuOTk5ODcyIDkuNjIzOTcgMUgyLjA2NjYyQzEuNDc3NTQgMSAxIDEuNDc3NTQgMSAyLjA2NjYyVjE1LjkzMjdDMSAxNi41MjE3IDEuNDc3NTQgMTYuOTk5MyAyLjA2NjYyIDE2Ljk5OTNIMyIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTE0Ljg2NjMgNi4zMzMxSDEwLjU5OThDMTAuMDEwNyA2LjMzMzEgOS41MzMyIDUuODU1NTUgOS41MzMyIDUuMjY2NDhWMSIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTguMzQ1MDMgMTdWMTEuNkw2LjkyMjUyIDE0LjNMNS41IDExLjZWMTciIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xMC4yNDEyIDE3VjExLjYiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xMC4yNDEyIDExLjZIMTAuNzE1NEMxMS41MDEgMTEuNiAxMi4xMzc5IDEyLjMyNTMgMTIuMTM3OSAxMy4yMkMxMi4xMzc5IDE0LjExNDcgMTEuNTAxIDE0Ljg0IDEwLjcxNTQgMTQuODRIMTAuMjQxMiIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTE2LjM2ODIgMTdWMTUuOTIiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xNi4zNjgyIDE1LjkyMDVWMTEuNjExM0MxNC44NzQ0IDEyLjQ1MDkgMTMuODIxOSAxNC4wNTE3IDEzLjUzNTIgMTUuOTIwNUgxNi4zNjgyIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";